const ITEMS = [
  "Audi", "BMW", "Mercedes-Benz", "Alfa Romeo", "Jeep", "Fiat", "Volkswagen",
  "Usato Garantito", "Km 0", "Finanziamenti su Misura", "Sub-Agenzia Assicurativa", "Permuta Usato",
];

export const Marquee = () => (
  <div
    className="relative border-y border-border bg-[#0D1119] py-5 overflow-hidden"
    data-testid="brand-marquee"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display font-bold uppercase tracking-[0.15em] text-xl text-gray-500 hover:text-amber-500 transition-colors px-6">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-amber-500/60 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
